import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { S25ButtonComponent } from "../s25.button.component";
import { S25IconComponent } from "../../modules/s25-icon/s25.icon.component";

@Component({
    selector: "s25-waitlist-group-toggle",
    template: `
        <s25-ng-button [type]="'flat'" (clicked)="toggle.emit()">
            <s25-ng-icon [type]="collapsed() ? 'caretRight' : 'caretDown'" [ariaLabel]="false" />
        </s25-ng-button>
    `,
    host: { style: "color: var(--s25-link-color, #2573a7)" },
    standalone: true,
    imports: [S25ButtonComponent, S25IconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WaitlistGroupToggleComponent {
    readonly collapsed = input(false);
    readonly waitlistId = input<number | null>();
    readonly toggle = output<void>();
}
